import Button from '@components/Button/Button'
import { useTranslation } from 'react-i18next'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styles from './Register.module.scss'
import OTPInput from '@/components/OtpInput/OtpInput'
import Keyboard from '@/components/Keyboard/Keyboard'
import { REGISTRATION_STEPS } from './models/registrationSteps.model'
import TextField from '@/components/TextField/TextField'
import { useSnackbar } from '@/components/Snackbar/SnackbarProvider'

function Register() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { showSnackbar } = useSnackbar()

  const [otp, setOtp] = useState('')
  const [title, setTitle] = useState(
    t('AUTHORIZATION.REGISTER.EMAIL_STEP.TITLE')
  )

  const setOtpValue = (digit: number) => {
    if (otp.length < 6) {
      setOtp(prev => prev + digit.toString())
    }
  }

  const clearOtpValue = () => {
    setOtp('')
  }

  const deleteLastOtpDigit = () => {
    setOtp(prev => prev.slice(0, -1))
  }

  useEffect(() => {
    if (otp.length === 6) {
      if (step === REGISTRATION_STEPS.CONFIRMATION_CODE) {
        if (otp === '123456') {
          setOtp('')
          setStep(REGISTRATION_STEPS.PIN)
          setTitle(t('AUTHORIZATION.REGISTER.PIN_STEP.TITLE'))
        } else {
          showSnackbar(
            t(
              'AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.VALIDATION.INVALID'
            ),
            'error'
          )
          setOtp('')
        }
      } else if (step === REGISTRATION_STEPS.PIN) {
        if (otp === '123456') {
          setOtp('')
          setStep(REGISTRATION_STEPS.CONFIRMATION_PIN)
          setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_PIN_STEP.TITLE'))
        } else {
          showSnackbar(
            t('AUTHORIZATION.REGISTER.PIN_STEP.VALIDATION.INVALID'),
            'error'
          )
          setOtp('')
        }
      } else if (step === REGISTRATION_STEPS.CONFIRMATION_PIN) {
        if (otp === '123456') {
          handleFinalSuccess()
        } else {
          showSnackbar(
            t(
              'AUTHORIZATION.REGISTER.CONFIRMATION_PIN_STEP.VALIDATION.INVALID'
            ),
            'error'
          )
          setOtp('')
        }
      }
    }
  }, [otp])

  const [step, setStep] = useState(
    () => sessionStorage.getItem('registrationStep') || REGISTRATION_STEPS.EMAIL
  )

  const [email, setEmail] = useState(
    () => sessionStorage.getItem('registrationEmail') || ''
  )

  useEffect(() => {
    sessionStorage.setItem('registrationStep', step)
    sessionStorage.setItem('registrationEmail', email)
  }, [step, email])

  const handleFinalSuccess = () => {
    sessionStorage.removeItem('registrationStep')
    sessionStorage.removeItem('registrationEmail')
    navigate('/tables-list')
  }

  const handleNext = () => {
    if (step === REGISTRATION_STEPS.EMAIL) {
      if (!email) {
        showSnackbar(
          t('AUTHORIZATION.REGISTER.EMAIL_STEP.VALIDATION.REQUIRED'),
          'error'
        )
      } else {
        setStep(REGISTRATION_STEPS.CONFIRMATION_CODE)
        setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.TITLE'))
      }
    } else if (step === REGISTRATION_STEPS.CONFIRMATION_CODE) {
      setStep(REGISTRATION_STEPS.PIN)
      setTitle(t('AUTHORIZATION.REGISTER.PIN_STEP.TITLE'))
    } else if (step === REGISTRATION_STEPS.PIN) {
      setStep(REGISTRATION_STEPS.CONFIRMATION_PIN)
      setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_PIN_STEP.TITLE'))
    } else if (step === REGISTRATION_STEPS.CONFIRMATION_PIN) {
      handleFinalSuccess()
    }
  }

  const handlePrev = () => {
    if (step === REGISTRATION_STEPS.CONFIRMATION_PIN) {
      setStep(REGISTRATION_STEPS.PIN)
      setTitle(t('AUTHORIZATION.REGISTER.PIN_STEP.TITLE'))
    } else if (step === REGISTRATION_STEPS.PIN) {
      setStep(REGISTRATION_STEPS.CONFIRMATION_CODE)
      setTitle(t('AUTHORIZATION.REGISTER.CONFIRMATION_CODE_STEP.TITLE'))
    } else if (step === REGISTRATION_STEPS.CONFIRMATION_CODE) {
      setStep(REGISTRATION_STEPS.EMAIL)
      setTitle(t('AUTHORIZATION.REGISTER.EMAIL_STEP.TITLE'))
      setEmail('')
    }
  }

  useEffect(() => {
    if (step === REGISTRATION_STEPS.EMAIL) {
      setTitle(t('AUTHORIZATION.REGISTER.EMAIL_STEP.TITLE'))
    }
  }, [step, t])

  return (
    <div className={`${styles.registerContainer}`}>
      <h1 className={`title-bold-medium ${styles.registerHeader}`}>{title}</h1>
      {step === REGISTRATION_STEPS.EMAIL ? (
        <TextField
          focused
          label={t('AUTHORIZATION.REGISTER.EMAIL')}
          minWidth="22.5rem"
          onChange={e => setEmail(e.target.value)}
        />
      ) : (
        <OTPInput setOtp={setOtp} otp={otp} />
      )}
      {step !== REGISTRATION_STEPS.EMAIL && (
        <Keyboard
          setValue={setOtpValue}
          clearValue={clearOtpValue}
          deleteValue={deleteLastOtpDigit}
        />
      )}
      <div className={`${styles.registerFormButtonContainer}`}>
        <Button
          onClick={step !== REGISTRATION_STEPS.EMAIL ? handlePrev : handleNext}
          label={
            step !== REGISTRATION_STEPS.EMAIL
              ? t('AUTHORIZATION.REGISTER.PREV')
              : t('AUTHORIZATION.REGISTER.NEXT')
          }
          variant="contained"
          color={step !== REGISTRATION_STEPS.EMAIL ? 'secondary' : 'primary'}
          maxWidth
          mobile
        />
      </div>
    </div>
  )
}

export default Register
